import Vue from 'vue'
import Router from 'vue-router'
import Layout from '@/views/layout/Layout'
Vue.use(Router)
export const constantRouterMap = [
  {
    path: '',
    name: 'login',
    // redirect: { path: '/data/realTime' },
    hidden: true, // 是否隐藏
    haveChild: false, // 是否含二级
    component: (resolve) => require(['@/views/Login/LoginIndex'], resolve),
    meta: {
      roles: [],
      icon: 'icon-manage',
      title: '登录',
      ignore: true
    }
  },
  {
    path: '/permission',
    name: 'permission',
    // redirect: { path: '/data/realTime' },
    hidden: true, // 是否隐藏
    haveChild: false, // 是否含二级
    component: (resolve) => require(['@/views/Setting/Role/permission'], resolve),
    meta: {
      roles: [],
      icon: 'icon-manage',
      title: '权限配置',
      ignore: true
    }
  }
]

// 注册路由
export default new Router({
  routes: constantRouterMap
})
// 动态路由
export const asyncRouterMap = [
  {
    path: '/screen',
    name: 'screen',
    hidden: true, // 是否隐藏
    haveChild: false, // 是否含二级
    component: (resolve) => require(['@/views/Screen'], resolve),
    meta: {
      roles: ['screen', 'company_manager'],
      icon: 'icon-manage',
      title: '可视化',
      ignore: true
    }
  },
  {
    path: '/data',
    hidden: false, // 是否隐藏
    haveChild: true, // 是否含二级
    component: Layout,
    meta: {
      roles: ['detection', 'company_manager'],
      icon: 'icon-data',
      title: '数据监测'
    },
    children: [
      {
        path: 'realTime',
        name: 'realTime',
        hidden: false,
        component: (resolve) => require(['@/views/Data/RealTime'], resolve),
        meta: {
          roles: ['monitor', 'company_manager'],
          icon: '',
          title: '实时监控'
        }
      },
      {
        path: 'statement',
        name: 'statement',
        hidden: false,
        component: (resolve) => require(['@/views/Data/Statement'], resolve),
        meta: {
          roles: ['electricalParameterReport', 'company_manager'],
          icon: '',
          title: '电参量报表'
        }
      },
      {
        path: 'monitor',
        name: 'monitor',
        hidden: true,
        navName: '/data/realTime',
        component: (resolve) => require(['@/views/Data/Monitor'], resolve),
        meta: {
          roles: ['monitor', 'company_manager'],
          icon: '',
          title: '数据监控'
        }
      },
      {
        path: 'deviceInfo',
        name: 'deviceInfo',
        hidden: true,
        navName: '/data/realTime',
        component: (resolve) => require(['@/views/Data/Monitor/deviceInfo'], resolve),
        meta: {
          roles: ['monitor', 'company_manager'],
          icon: '',
          title: '数据信息'
        }
      }
    ]
  },
  {
    path: '/energy',
    hidden: false, // 是否隐藏
    haveChild: true, // 是否含二级
    component: Layout,
    meta: {
      roles: ['energy', 'company_manager'],
      icon: 'icon-energy',
      title: '能耗分析'
    },
    children: [
      {
        path: 'general',
        name: 'general',
        hidden: false,
        component: (resolve) => require(['@/views/Energy/General'], resolve),
        meta: {
          roles: ['energyConsumptionOverview', 'company_manager'],
          icon: '',
          title: '能耗概况'
        }
      },
      {
        path: 'loopRatio',
        name: 'loopRatio',
        hidden: false,
        component: (resolve) => require(['@/views/Energy/LoopRatio'], resolve),
        meta: {
          roles: ['monthOnMonthAnalysis', 'company_manager'],
          icon: '',
          title: '环比分析'
        }
      },
      {
        path: 'report',
        name: 'report',
        hidden: false,
        component: (resolve) => require(['@/views/Energy/Report'], resolve),
        meta: {
          roles: ['energyConsumptionReport', 'company_manager'],
          icon: '',
          title: '能耗报表'
        }
      },
      {
        path: 'multiRate',
        name: 'multiRate',
        hidden: false,
        component: (resolve) => require(['@/views/Energy/MultiRate'], resolve),
        meta: {
          roles: ['compoundRateReport', 'company_manager'],
          icon: '',
          title: '复费率报表'
        }
      },
      {
        path: 'electric',
        name: 'electric',
        hidden: false,
        component: (resolve) => require(['@/views/Energy/Electric'], resolve),
        meta: {
          roles: ['electricEnergyReport', 'company_manager'],
          icon: '',
          title: '电能报表'
        }
      },
      {
        path: 'flow',
        name: 'flow',
        hidden: true,
        component: (resolve) => require(['@/views/Energy/Flow'], resolve),
        meta: {
          roles: ['energy-6', 'company_manager'],
          icon: '',
          title: '能源流向'
        }
      }
    ]
  },
  {
    path: '/quality',
    hidden: false, // 是否隐藏
    haveChild: true, // 是否含二级
    component: Layout,
    meta: {
      roles: ['quality', 'company_manager'],
      icon: 'icon-quality',
      title: '电能质量'
    },
    children: [
      {
        path: 'harmonic',
        name: 'harmonic',
        hidden: false,
        component: (resolve) => require(['@/views/quality/harmonic/harmonic'], resolve),
        meta: {
          roles: ['harmonic', 'company_manager'],
          icon: '',
          title: '谐波监测'
        }
      },
      {
        path: 'threeImbalance',
        name: 'threeImbalance',
        hidden: false,
        component: (resolve) => require(['@/views/quality/threeImbalance/threeImbalance'], resolve),
        meta: {
          roles: ['threePhaseUnbalance', 'company_manager'],
          icon: '',
          title: '三相不平衡'
        }
      },
      {
        path: 'steadyState',
        name: 'steadyState',
        hidden: true,
        component: (resolve) => require(['@/views/quality/steadyState/steadyState'], resolve),
        meta: {
          roles: ['quality-3', 'company_manager'],
          icon: '',
          title: '稳态监测'
        }
      },
      {
        path: 'HarmonicSpectrum',
        name: 'HarmonicSpectrum',
        hidden: true,
        component: (resolve) => require(['@/views/quality/HarmonicSpectrum/HarmonicSpectrum'], resolve),
        meta: {
          roles: ['quality-4', 'company_manager'],
          icon: '',
          title: '谐波频谱'
        }
      },
      {
        path: 'steadyCurve',
        name: 'steadyCurve',
        hidden: true,
        component: (resolve) => require(['@/views/quality/steadyCurve/steadyCurve'], resolve),
        meta: {
          roles: ['quality-5', 'company_manager'],
          icon: '',
          title: '稳态曲线'
        }
      },
      {
        path: 'transientAnalysis',
        name: 'transientAnalysis',
        hidden: true,
        component: (resolve) => require(['@/views/quality/transientAnalysis/transientAnalysis'], resolve),
        meta: {
          roles: ['quality-6', 'company_manager'],
          icon: '',
          title: '暂态分析'
        }
      },
      {
        path: 'loadCurve',
        name: 'loadCurve',
        hidden: true,
        component: (resolve) => require(['@/views/quality/loadCurve/loadCurve'], resolve),
        meta: {
          roles: ['quality-7', 'company_manager'],
          icon: '',
          title: '负荷曲线'
        }
      },
      {
        path: 'soeEvent',
        name: 'soeEvent',
        hidden: true,
        component: (resolve) => require(['@/views/quality/soeEvent/soeEvent'], resolve),
        meta: {
          roles: ['quality-8', 'company_manager'],
          icon: '',
          title: 'SOE事件'
        }
      }
    ]
  },
  {
    path: '/demand',
    hidden: false, // 是否隐藏
    haveChild: true, // 是否含二级
    component: Layout,
    meta: {
      roles: ['demandAnalysis', 'company_manager'],
      icon: 'icon-demand',
      title: '需量分析'
    },
    children: [
      {
        path: 'demandReport',
        name: 'demandReport',
        hidden: false,
        component: (resolve) => require(['@/views/demand/demandReport'], resolve),
        meta: {
          roles: ['maximumDemandReport', 'company_manager'],
          icon: '',
          title: '最大需量报表'
        }
      },
      {
        path: 'demandMonitor',
        name: 'demandMonitor',
        hidden: false,
        component: (resolve) => require(['@/views/demand/demandMonitor'], resolve),
        meta: {
          roles: ['demandMonitoring', 'company_manager'],
          icon: '',
          title: '需量监测'
        }
      }
    ]
  },
  {
    path: '/hidden',
    hidden: false, // 是否隐藏
    haveChild: true, // 是否含二级
    component: Layout,
    meta: {
      roles: ['hidden', 'company_manager'],
      icon: 'icon-hidden',
      title: '隐患管理'
    },
    children: [
      {
        path: 'hiddenSearch',
        name: 'hiddenSearch',
        hidden: false,
        component: (resolve) => require(['@/views/hidden/hiddenSearch'], resolve),
        meta: {
          roles: ['hiddenDangerQuery', 'company_manager'],
          icon: '',
          title: '隐患查询'
        }
      },
      {
        path: 'hiddenDetail',
        name: 'hiddenDetail',
        hidden: true,
        navName: '/hidden/hiddenSearch',
        component: (resolve) => require(['@/views/hidden/components/hiddenDetail'], resolve),
        meta: {
          roles: ['hiddenDangerQuery', 'company_manager'],
          icon: '',
          title: '隐患详情'
        }
      },
      {
        path: 'hiddenPayout',
        name: 'hiddenPayout',
        hidden: false,
        component: (resolve) => require(['@/views/hidden/hiddenPayout'], resolve),
        meta: {
          roles: ['hazardDistribution', 'company_manager'],
          icon: '',
          title: '隐患派发'
        }
      },
      {
        path: 'payoutDetail',
        name: 'payoutDetail',
        hidden: true,
        navName: '/hidden/hiddenPayout',
        component: (resolve) => require(['@/views/hidden/components/payoutDetail'], resolve),
        meta: {
          roles: ['hazardDistribution', 'company_manager'],
          icon: '',
          title: '派发详情'
        }
      },
      {
        path: 'hiddenDispose',
        name: 'hiddenDispose',
        hidden: false,
        component: (resolve) => require(['@/views/hidden/hiddenDispose'], resolve),
        meta: {
          roles: ['defectTreatment', 'company_manager'],
          icon: '',
          title: '隐患处理'
        }
      },
      {
        path: 'disposeDetail',
        name: 'disposeDetail',
        navName: '/hidden/hiddenDispose',
        hidden: true,
        component: (resolve) => require(['@/views/hidden/components/disposeDetail'], resolve),
        meta: {
          roles: ['defectTreatment', 'company_manager'],
          icon: '',
          title: '处理详情'
        }
      },
      {
        path: 'hiddenAnalysis',
        name: 'hiddenAnalysis',
        hidden: false,
        component: (resolve) => require(['@/views/hidden/hiddenAnalysis'], resolve),
        meta: {
          roles: ['hazardAnalysis', 'company_manager'],
          icon: '',
          title: '隐患分析'
        }
      }
    ]
  },
  {
    path: '/operation',
    hidden: false, // 是否隐藏
    haveChild: true, // 是否含二级
    component: Layout,
    meta: {
      roles: ['maintenance', 'company_manager'],
      icon: 'icon-operation',
      title: '运维管理'
    },
    children: [
      {
        path: 'patrolTrack',
        name: 'patrolTrack',
        hidden: false,
        component: (resolve) => require(['@/views/Operation/PatrolTrack'], resolve),
        meta: {
          roles: ['inspectionTrajectory', 'company_manager'],
          icon: '',
          title: '巡检轨迹'
        }
      },
      {
        path: 'patrolPlan',
        name: 'patrolPlan',
        hidden: false,
        component: (resolve) => require(['@/views/Operation/PatrolPlan'], resolve),
        meta: {
          roles: ['patrolScheme', 'company_manager'],
          icon: '',
          title: '巡检计划'
        }
      },
      {
        path: 'patrolRecord',
        name: 'patrolRecord',
        hidden: false,
        component: (resolve) => require(['@/views/Operation/PatrolRecord'], resolve),
        meta: {
          roles: ['inspectionRecords', 'company_manager'],
          icon: '',
          title: '巡检记录'
        }
      },
      {
        path: 'defect',
        name: 'defect',
        hidden: false,
        component: (resolve) => require(['@/views/Operation/Defect'], resolve),
        meta: {
          roles: ['defectRecord', 'company_manager'],
          icon: '',
          title: '缺陷记录'
        }
      },
      {
        path: 'message',
        name: 'message',
        hidden: false,
        component: (resolve) => require(['@/views/Operation/Message'], resolve),
        meta: {
          roles: ['communicationStatus', 'company_manager'],
          icon: '',
          title: '通讯状态'
        }
      },
      {
        path: 'score',
        name: 'score',
        hidden: false,
        component: (resolve) => require(['@/views/Operation/Score'], resolve),
        meta: {
          roles: ['inspectionScore', 'company_manager'],
          icon: '',
          title: '巡检评分'
        }
      }
    ]
  },
  {
    path: '/analyze',
    hidden: false, // 是否隐藏
    haveChild: true, // 是否含二级
    component: Layout,
    meta: {
      roles: ['report', 'company_manager'],
      icon: 'icon-analyze',
      title: '报告分析'
    },
    children: [
      {
        path: 'userReport',
        name: 'userReport',
        hidden: false,
        component: (resolve) => require(['@/views/Analyze/userReport'], resolve),
        meta: {
          roles: ['userReports', 'company_manager'],
          icon: '',
          title: '用户报告'
        }
      }
    ]
  },
  {
    path: '/base',
    hidden: false, // 是否隐藏
    haveChild: true, // 是否含二级
    component: Layout,
    meta: {
      roles: ['basicData', 'company_manager'],
      icon: 'icon-base',
      title: '基础数据管理'
    },
    children: [
      {
        path: 'paramsSet',
        name: 'paramsSet',
        hidden: false,
        component: (resolve) => require(['@/views/Base/ParamsSet'], resolve),
        meta: {
          roles: ['parameterSettingManagement', 'company_manager'],
          icon: '',
          title: '参数设置管理'
        }
      },
      {
        path: 'patrolItem',
        name: 'patrolItem',
        hidden: false,
        component: (resolve) => require(['@/views/Base/PatrolItem'], resolve),
        meta: {
          roles: ['inspectionItemManagement', 'company_manager'],
          icon: '',
          title: '巡检项管理'
        }
      },
      {
        path: 'fireDevice',
        name: 'fireDevice',
        hidden: true,
        component: (resolve) => require(['@/views/Base/FireDevice'], resolve),
        meta: {
          roles: ['base-3', 'company_manager'],
          icon: '',
          title: '消防设施管理'
        }
      }
    ]
  },
  {
    path: '/log',
    hidden: false, // 是否隐藏
    haveChild: true, // 是否含二级
    component: Layout,
    meta: {
      roles: ['log'],
      icon: 'icon-log',
      title: '日志管理'
    },
    children: [
      {
        path: 'loginLog',
        name: 'loginLog',
        hidden: false,
        component: (resolve) => require(['@/views/Log/LoginLog'], resolve),
        meta: {
          roles: ['loginLog'],
          icon: '',
          title: '登录日志'
        }
      },
      {
        path: 'operationLog',
        name: 'operationLog',
        hidden: false,
        component: (resolve) => require(['@/views/Log/OperationLog'], resolve),
        meta: {
          roles: ['operationLog'],
          icon: '',
          title: '操作日志'
        }
      },
      {
        path: 'controlLog',
        name: 'controlLog',
        hidden: false,
        component: (resolve) => require(['@/views/Log/ControlLog'], resolve),
        meta: {
          roles: ['controlLog'],
          icon: '',
          title: '控制日志'
        }
      }
    ]
  },
  {
    path: '/setting',
    hidden: false, // 是否隐藏
    haveChild: true, // 是否含二级
    component: Layout,
    meta: {
      roles: ['system'],
      icon: 'el-icon-setting',
      title: '系统配置'
    },
    children: [
      {
        path: 'company',
        name: 'company',
        hidden: false,
        component: (resolve) => require(['@/views/Setting/Company'], resolve),
        meta: {
          roles: ['enterpriseManagement'],
          icon: '',
          title: '企业管理'
        }
      },
      {
        path: 'loop',
        name: 'loop',
        hidden: false,
        component: (resolve) => require(['@/views/Setting/Loop'], resolve),
        meta: {
          roles: ['loopManagement'],
          icon: '',
          title: '回路管理'
        }
      },
      {
        path: 'basemap',
        name: 'basemap',
        hidden: true,
        navName: '/setting/loop',
        component: (resolve) => require(['@/views/Setting/Loop/basemap'], resolve),
        meta: {
          roles: ['loopManagement'],
          icon: '',
          title: '一次图'
        }
      },
      {
        path: 'basemap2',
        name: 'basemap2',
        hidden: true,
        navName: '/setting/area',
        component: (resolve) => require(['@/views/Setting/Loop/basemap'], resolve),
        meta: {
          roles: ['regionManagement'],
          icon: '',
          title: '平面图'
        }
      },
      {
        path: 'gateway',
        name: 'gateway',
        hidden: false,
        component: (resolve) => require(['@/views/Setting/Gateway'], resolve),
        meta: {
          roles: ['gatewayManagement'],
          icon: '',
          title: '网关管理'
        }
      },
      {
        path: 'area',
        name: 'area',
        hidden: false,
        component: (resolve) => require(['@/views/Setting/Area'], resolve),
        meta: {
          roles: ['regionManagement'],
          icon: '',
          title: '区域管理'
        }
      },
      {
        path: 'device',
        name: 'device',
        hidden: false,
        component: (resolve) => require(['@/views/Setting/Device'], resolve),
        meta: {
          roles: ['slaveManagement'],
          icon: '',
          title: '从机管理'
        }
      },
      {
        path: 'role',
        name: 'role',
        hidden: false,
        component: (resolve) => require(['@/views/Setting/Role'], resolve),
        meta: {
          roles: ['roleManagement'],
          icon: '',
          title: '角色管理'
        }
      },
      {
        path: 'user',
        name: 'user',
        hidden: false,
        component: (resolve) => require(['@/views/Setting/User'], resolve),
        meta: {
          roles: ['userManagement'],
          icon: '',
          title: '用户管理'
        }
      },
      {
        path: 'systemConfig',
        name: 'systemConfig',
        hidden: false,
        component: (resolve) => require(['@/views/Setting/systemConfig/systemConfig'], resolve),
        meta: {
          roles: ['systemManagement'],
          icon: '',
          title: '系统配置'
        }
      }
    ]
  }
]
